exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.collapse-transition[data-v-c4f0b3f8] {\n    max-height: 500px;\n    transition: max-height 0.2s ease-in-out;\n}\n.collapsed[data-v-c4f0b3f8] {\n    max-height: 0;\n    overflow: hidden;\n}\n", ""]);

// exports
